import {h, Fragment} from "preact"
import { RangeSlider, useRangeSlider } from "@nosto/preact"
import { useState } from "preact/hooks"
import RangeInput from "./elements/RangeInput"
import Icon from "./elements/Icon"

export default function RangeFacet({ facet }) {
    const { min, max, range, updateRange } = useRangeSlider(facet.id)
    const isSelected = min !== range[0] || max !== range[1]
    const [active, setActive] = useState(isSelected)

    return (
        <li class={`ns-sidebar-dropdown ns-facet-list-item ${active ? "ns-active" : ""}`}>
            <a
                class="ns-facet-container"
                href="javascript:void(0)"
                onClick={() => {
                    setActive(!active)
                }}
            >
                <span class="ns-facet-name">{facet.name}</span>
                {/* {isSelected && (
                    <span class="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                        {1}
                    </span>
                )} */}
                {active ?
                    (<span class="ns-facet-icon-minus">
                        <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.615234" y="1.76917" width="1.53846" height="10.7692" transform="rotate(-90 0.615234 1.76917)" fill="#0A4875" />
                        </svg>
                    </span>) : (
                        <span class="ns-facet-icon-plus">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="4.61572" y="10.7692" width="1.53846" height="10.7692" transform="rotate(-90 4.61572 10.7692)" fill="#0A4875" />
                                <rect x="10.769" y="15.3845" width="1.53846" height="10.7692" transform="rotate(180 10.769 15.3845)" fill="#0A4875" />
                            </svg>
                        </span>
                    )}
            </a>
            <div class={active ? "ns-sidebar-submenu ns-facet-menu" : "ns-d-none"}>
                <div class="ns-d-flex ns-justify-content-between ns-font-4 ns-relative">
                    <div class="ns-col-6 flex-shrink-1 ns-mr-2 ns-range-input-container">
                        {/* <label for={`ns-${facet.id}-min`} class="ns-form-label">
                            Min.
                        </label> */}
                        <RangeInput
                            id={`ns-${facet.id}-min`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[0]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([value, range[1]])
                            }}
                        />
                    </div>
                    <div class="ns-col-6 flex-shrink-1 ns-range-input-container">
                        {/* <label for={`ns-${facet.id}-max`} class="ns-form-label">
                            Max.
                        </label> */}
                        <RangeInput
                            id={`ns-${facet.id}-max`}
                            min={min}
                            max={max}
                            range={range}
                            value={range[1]}
                            onChange={e => {
                                const value = parseFloat(e.currentTarget.value) || undefined
                                updateRange([range[0], value])
                            }}
                        />
                    </div>
                </div>
                <RangeSlider id={facet.id} />
            </div>
        </li>
    )
}
